export * from './WakeLocker';
export { default } from './WakeLocker';
